import { defineComponent } from 'vue';
export default defineComponent({
  name: 'GuardiansSection',
  data() {
    return {
      activeGuardian: 'k'
    };
  }
});